import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    buckets: {},
    dataBuckets: false
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/products/index.js